import { msalInitPromise, msalInstance } from "app/auth/msalInstance";
import { createLocalApi } from "./util";

export async function getLocalApi() {
    await msalInitPromise;
    return createLocalApi(msalInstance);
}